import React from 'react';

interface AppShotProps {
  src: string;
  alt: string;
  caption?: string;
  priority?: boolean;
}

export const AppShot: React.FC<AppShotProps> = ({ src, alt, caption, priority = false }) => {
  return (
    <figure className="app-shot">
      <div className="app-shot-frame">
        <img
          src={src}
          alt={alt}
          width={1440}
          height={900}
          loading={priority ? 'eager' : 'lazy'}
          decoding="async"
        />
      </div>
      {caption ? <figcaption>{caption}</figcaption> : null}
    </figure>
  );
};
